// extracted by mini-css-extract-plugin
export default {"dashboard":"Layout_dashboard__CDH8l","main":"Layout_main__EfOal","container":"Layout_container__9sl+s","profileMain":"Layout_profileMain__671WS"};